import { useState, useEffect } from 'react'
import { getLeaveStatusFullAPI } from '../services/welfare-leave'

function UseLeaveStatusFull() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const resp = await getLeaveStatusFullAPI()
      if (!resp) return
      if (resp.status) {
        const newData = resp.result.map((d, i) => {
          return {
            value: d.leaveStatusId,
            label: `${d.leaveStatus} `
          }
        })
        setData(newData)
      } else {
        setData([])
      }
    }
    getData()
  }, [])
  return data
}

export default UseLeaveStatusFull
